import COUNTRIES from '../countries.translations'

import translations from './arsenic.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/arsenic'

export const arsenic: Metal = {
  id: 39,
  slug: 'arsenic',
  name: t.name,
  symbol: 'As',
  // Processing facilities, not mines; coordinates geocoded from the sheet's place names.
  mines: [
    {
      name: 'Gejiu, arsenic processing facility (China)',
      region: t.mine0Region,
      slug: 'gejiu',
      coordinates: [103.15, 23.36],
    },
    {
      name: 'Zhuzhou, arsenic processing facility (China)',
      region: t.mine1Region,
      slug: 'zhuzhou',
      coordinates: [113.13, 27.83],
    },
    {
      name: 'Marrakech, arsenic processing facility (Morocco)',
      region: t.mine2Region,
      slug: 'marrakech',
      coordinates: [-8.0, 31.63],
    },
    {
      name: 'Ilo, arsenic processing facility (Peru)',
      region: t.mine3Region,
      slug: 'ilo',
      coordinates: [-71.34, -17.64],
    },
    {
      name: 'Antwerp, arsenic processing facility (Belgium)',
      region: t.mine4Region,
      slug: 'antwerp',
      coordinates: [4.4, 51.22],
    },
  ],
  countries: [
    { name: COUNTRIES.peru, percent: 46.6 },
    { name: COUNTRIES.china, percent: 41.4 },
    { name: COUNTRIES.morocco, percent: 10.3 },
    { name: COUNTRIES.belgium, percent: 1.7 },
    { name: COUNTRIES.russia, percent: 0.3 },
    { name: COUNTRIES.japan, percent: 0.1 },
  ],
  // Recovered from the smelting of all four, never mined for itself.
  related: ['gold', 'copper', 'cobalt', 'lead'],
  content: {
    smartphone: {
      quantityScore: 1,
      quantityLabel: t.smartphone.label,
      parts: ['screen', 'electronics'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: null, ...t.impacts.environmental },
      human: { severity: 1, ...t.impacts.human },
      geopolitical: { severity: 3, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: null, ...t.supplyRisk },
    recycling: { score: 1, ...t.recycling },
    footnotes: t.footnotes,
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
      firstBento: [
        {
          src: `${dir}/02.jpg`,
          orientation: 'horizontal',
        },
      ],
    },
  },
}
